import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { get } from 'lodash';
import { blue100 } from '@zocdoc-mezzanine/foundations-colors';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { Column } from '@zocdoc-frontend-common/styles-grid';
import Button from '@zocdoc-frontend-common/components-button';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { sendPostRequestToPgs } from './PgsRequests.js';

export class Survey extends Component {
    static propTypes = {
        onSubmitSurvey: PropTypes.func,
        surveySubmitted: PropTypes.bool,
        surveyQuestionsData: PropTypes.shape({
            questions: PropTypes.arrayOf(
                PropTypes.shape({
                    answers_selected: PropTypes.arrayOf(
                        PropTypes.shape({
                            answer_id: PropTypes.number,
                            display_text: PropTypes.string,
                            free_text_response: PropTypes.string,
                            is_free_text: PropTypes.bool,
                        })
                    ),
                    display_text: PropTypes.string,
                    event_timestamp_utc: PropTypes.string,
                    event_type: PropTypes.string,
                    input_type: PropTypes.string,
                    possible_answers: PropTypes.arrayOf(
                        PropTypes.shape({
                            answer_id: PropTypes.number,
                            display_text: PropTypes.string,
                            free_text_response: PropTypes.string,
                            is_free_text: PropTypes.bool,
                        })
                    ),
                    question_id: PropTypes.number,
                    question_order: PropTypes.number,
                })
            ),
            booking_id: PropTypes.string,
            client_platform: PropTypes.string,
            session_id: PropTypes.string,
            survey_id: PropTypes.string,
            survey_type: PropTypes.string,
            survey_subtype: PropTypes.string,
            tracking_id: PropTypes.string,
            user_agent: PropTypes.string,
        }),
    };

    state = {
        answersSelected: [],
    };

    componentDidMount() {
        const { bookingId, surveyQuestionsData } = this.props;
        sendPostRequestToPgs(bookingId, surveyQuestionsData, 'view');
    }

    render() {
        const { surveyQuestionsData } = this.props;
        const questionTitleText = get(
            surveyQuestionsData,
            'questions[0].display_text'
        );

        return this.maybeRenderSurveyContainer(questionTitleText);
    }

    maybeRenderSurveyContainer = questionTitleText => {
        const { surveySubmitted } = this.props;
        if (!surveySubmitted) {
            return (
                <SurveyContainer data-test="survey-container">
                    <QuestionTitle>{questionTitleText}</QuestionTitle>
                    <PossibleAnswersContainer>
                        {this.renderAnswerOptions()}
                    </PossibleAnswersContainer>
                </SurveyContainer>
            );
        } else {
            return (
                <SurveyContainer data-test="survey-container-thanks">
                    <ThankYouTitle>Thanks!</ThankYouTitle>
                    <ThankYouSubTitle>
                        <br />
                        We appreciate your feedback.
                        <br />
                        Please wait while we finish booking your appointment.
                    </ThankYouSubTitle>
                </SurveyContainer>
            );
        }
    };

    renderAnswerOptions = () => {
        //TOOD: This current implementation of the onClick event and subsequent handleSurveySubmit
        // does not allow for the submission of multiple answers. If we want to implement this in the future,
        // we will need to only add the answer option to the answerSelected array in the state
        // and wait to submit until an additional onClick is triggered for a submit button
        const { surveyQuestionsData } = this.props;
        const answers = surveyQuestionsData.questions[0].possible_answers;
        const answerElements = answers.map(pa => (
            <AnswerOption
                data-test="answer-option"
                onClick={() => this.handleSurveySubmit(pa)}
                key={pa.answer_id}
            >
                {pa.display_text}
            </AnswerOption>
        ));
        return answerElements;
    };

    handleSurveySubmit = async answerSelected => {
        const { bookingId, onSubmitSurvey, surveyQuestionsData } = this.props;
        // TODO: The multi answer submission portion of the survey is not implemented yet.
        // Thus the answersSelected state field is implemented but not used
        this.setState({
            surveySubmitted: true,
            answersSelected: this.state.answersSelected.push(answerSelected),
        });

        const answersSelected = {
            answer_id: parseInt(answerSelected.answer_id),
            display_text: answerSelected.display_text,
            is_free_text: false,
            free_text_response: null,
        };

        onSubmitSurvey();

        sendPostRequestToPgs(
            bookingId,
            surveyQuestionsData,
            'submit',
            answersSelected
        );
    };
}

const ThankYouTitle = styled.div`
    color: ${blue100};
    font: 20px ${FontFamily.SharpSansBold};
`;

const ThankYouSubTitle = styled.div`
    color: ${blue100};
    font: 20px ${FontFamily.SharpSansMedium};
    text-align: center;
`;

const SurveyContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    min-height: 80vh;
    background-color: #f3f3f4;
    width: 100%;
    padding-bottom: 30px;
`;

const PossibleAnswersContainer = styled(Column)`
    width: 92%;
    text-align: center;
    margin: 0 3% 0 3%;
    ${breakpoint.small} {
        width: 384px;
        margin: 0 17px 0 17px;
    }
`;

const QuestionTitle = styled.div`
    color: ${blue100};
    text-align: center;
    font: 16px ${FontFamily.SharpSansBold};
    padding: 16px 24px 8px 24px;
    ${breakpoint.small} {
        padding: 40px 0px 40px 0px;
        font: 28px ${FontFamily.SharpSansBold};
    }
`;

const AnswerOption = styled(Button)`
    display: flex;
    justify-content: center;
    align-items: center;
    background: white;
    border-color: white;
    height: 36px;
    width: 92%;
    margin: 0 0 10px 0;
    ${breakpoint.small} {
        width: 350px;
    }
`;
